import Vue from 'vue';
import { sleep } from '@/tools/sleep';
import setMediaObjectsSources from '@/tools/setMediaObjectsSources';
import getArticleVersion from './utils/getArticleVersion';
import { mutationTypes, actionTypes, errorTypes } from '@/types';

const articleIsLoading = new Set();

/**
 *
 * @param {*} store
 * @param { articleID, exhibitionID, modal } options modal indicates the content is loading for Content Modal
 */

export default async function fetchArticleContent(
	{ commit, state, getters, dispatch },
	{ articleID, exhibitionID }
) {
	// handle all other articles pre rendered by cms
	const language = getters.currentLanguage;
	const articleVersion = getArticleVersion({ state, articleID, exhibitionID });

	// Test for virtualPackageSyncer if Package is downloaded it only works not in preview mode.
	// Beacause of package indexing for that this check will not be applied
	if (state.isVirtualPackageSyncer && state.packageSyncer.isSyncerApp) {
		if (
			!state.isPreviewDataSource &&
			!state.packageSyncer.offlineAvailablePackagesIndex.has(`article-${articleID}-${articleVersion}`)
		) {
			await sleep(1000);
			dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.articleDownloadFailed) });
			return;
		}
	}
	const url = new URL(
		`./apps/article-${articleID}-${articleVersion}/${language}.content`,
		state.dataSourceURL
	);
	let result;
	try {
		result = await Vue.http.get(url.toString());
	} catch (error) {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.articleDownloadFailed) });
		articleIsLoading.delete(articleID);
		return;
	}

	if (Array.isArray(result.body.mediaObjects)) {
		commit(actionTypes.addToMediaObjectMap, {
			mediaObjectArray: setMediaObjectsSources(result.body.mediaObjects, state.dataSourceURL),
		});
	}
	commit(mutationTypes.setContentForArticle, { id: articleID, content: result.body, language });

	// Set Timeout to leave eventloop so content will be rendered before check for the dom elements
}
